// Stesse regole del backend (features/promoslides/service.js#isValidLink):
// vuoto, percorso interno del BO (mai "//") oppure URL http(s).
export const isValidLink = link => {
	if (!link) return true;
	if (/^\/(?!\/)/.test(link)) return true;
	return /^https?:\/\/[^\s]+$/i.test(link);
};

export const isExternalLink = link => /^https?:\/\//i.test(link || '');
